import EngineerSlides from './EngineerSlides';
import ProductSlides from './ProductSlides';
import SystemSlides from './SystemSlides';

export default class {
  constructor() {

    const EngineerSlidesDom = document.querySelector('[data-js="engineer-slide"]');
    if (EngineerSlidesDom) new EngineerSlides(EngineerSlidesDom);

    const ProductSlidesDom = document.querySelector('[data-js="product-slide"]');
    if (ProductSlidesDom) new ProductSlides(ProductSlidesDom);

    const SystemSlidesDom = document.querySelector('[data-js="system-slide"]');
    if (SystemSlidesDom) new SystemSlides(SystemSlidesDom);
  }
}
